import { STRING } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'

export default {
  label: 'Does not contain',
  operator: 'does not contain',
  fields: [ STRING ],
  isValidValue (value) {
    return isString(value) && value.length
  }
}
